import { tokenRefreshControl } from "../context/functions";
import { parseJwt } from "../context/functions";
import { ToastEmitter } from "../Services/assets/toast-emitter";
import {
	ConfirmUser,
	SignIn,
	SignInChallenge,
	SignUp,
} from "../Services/lib/auth";

export const AuthLogin = (
	body,
	Cookie,
	interval,
	setLogged,
	setTokens,
	setLoading = () => {},
	setUsername = () => {},
	openMFA = () => {},
	setSession = () => {},
	setUserSRP = () => {},
	setVerifyData = () => {},
	setOpen = () => {},
	setbrand = () => {}
) => {
	setLoading(true);
	SignIn({ body })
		.then((data) => {
			const cookies = new Cookie();
			if (data.ChallengeName === "SOFTWARE_TOKEN_MFA") {
				openMFA(true);
				setSession(data.Session);
				setUserSRP(data.ChallengeParameters.USER_ID_FOR_SRP);
				setLoading(false);
			} else {
				const dec = parseJwt(data.AuthenticationResult.AccessToken);
				if (data.x_brand) {
					if (dec["cognito:groups"][0] !== "admin")
						setbrand({ _id: data.x_brand });
				}
				cookies.set("refresh_token", data.AuthenticationResult.RefreshToken, {
					path: "/",
					maxAge: 23 * 3600,
				});
				cookies.set("username", dec.username, {
					path: "/",
					maxAge: 23 * 3600,
				});
				tokenRefreshControl(
					data.AuthenticationResult.RefreshToken,
					dec.username,
					interval,
					setTokens,
					setLogged
				);
				setLoading(false);
				setUsername(dec.username);
				setTokens({
					access_token: data.AuthenticationResult.AccessToken,
					id_token: data.AuthenticationResult.IdToken,
					id: dec.sub,
					group: dec["cognito:groups"][0],
					username: dec.username,
				});
				setLogged(true);
			}
		})
		.catch((err) => {
			// console.log(err);
			if (err?.response?.data?.message === "UserNotConfirmedException") {
				setOpen(true);
				setVerifyData((p) => {
					return { ...p, username: body.username };
				});
			}
			setLoading(false);
		});
};

export const AuthLoginMFA = (
	body,
	Cookie,
	interval,
	setLogged,
	setTokens,
	setLoading = () => {},
	setUsername = () => {},
	setVerifyData = () => {},
	setbrand = () => {}
) => {
	setLoading(true);
	SignInChallenge({ body })
		.then((data) => {
			if (data.x_brand) {
				setbrand({ _id: data.x_brand });
			}
			const cookies = new Cookie();
			const dec = parseJwt(data.AuthenticationResult.AccessToken);
			setTokens({
				access_token: data.AuthenticationResult.AccessToken,
				id_token: data.AuthenticationResult.IdToken,
				id: dec.sub,
				group: dec["cognito:groups"][0],
				username: dec.username,
			});
			cookies.set("refresh_token", data.AuthenticationResult.RefreshToken, {
				path: "/",
				maxAge: 23 * 3600,
			});
			cookies.set("username", dec.username, {
				path: "/",
				maxAge: 23 * 3600,
			});
			tokenRefreshControl(
				data.AuthenticationResult.RefreshToken,
				dec.username,
				interval,
				setTokens,
				setLogged
			);
			setUsername(dec.username);
			setLogged(true);
			setLoading(false);
		})
		.catch((err) => {
			if (err.response.data.message === "UserNotConfirmedException") {
				setVerifyData((p) => {
					return { ...p, username: body.username };
				});
			}
			setLoading(false);
		});
};

export const AuthSignUp = (
	body,
	setVerifyData = () => {},
	onConfirm = () => {},
	setLoading = () => {}
) => {
	let data = {
		username: body.username,
		password: body.password,
		email: body.email,
		uniqueCode: body.uniqueCode,
	};

	if (body.org && body.chosen) {
		data = {
			...data,
			chosenOrg: body.org,
			role: body.chosen,
			isDash: true,
		};
	}

	setLoading(true);
	SignUp({ body: data })
		.then(() => {
			ToastEmitter({
				msg: "Your account has been created. Please check your email.",
				type: "success",
			});
			setVerifyData((p) => {
				return { ...p, username: body.username };
			});
			setLoading(false);
			onConfirm(false);
		})
		.catch(() => {
			setLoading(false);
		});
};

export const AuthVerify = (body, setLoading = () => {}, history) => {
	const data = {
		username: body.username,
		confirmationCode: body.confirmationCode,
	};
	setLoading(true);
	ConfirmUser({ body: data })
		.then(() => {
			setLoading(false);
			ToastEmitter({
				msg: "Your account successfully enabled. Please login",
				type: "success",
			});
			history.push("/");
		})
		.catch((err) => {
			setTimeout(() => {
				setLoading(false);
			}, 5000);
		});
};
